export enum LifecyclePhase {
  APP_LAUNCH = 'app:launch',
  LOGOUT = 'logout',
  SESSION_INIT = 'session:init',
  TOKEN_REFRESH = 'token:refresh',
}
